export type SupportStep='열기'|'저장'|'백업'|'가져오기'|'기타';
export function supportMailto(step:SupportStep,build:string,channel:string,ua:string):string {
 const browser=/SamsungBrowser/i.test(ua)?'삼성':/Chrome|CriOS/i.test(ua)?'크롬':/Safari/i.test(ua)?'사파리':'기타';
 return `mailto:support@munops.com?subject=${encodeURIComponent(`[보도차이] ${step}`)}&body=${encodeURIComponent(`막힌 단계: ${step}\n버전: ${build}\n채널: ${channel}\n브라우저: ${browser}\n\n기사 주소·메모·비밀번호·백업 파일은 붙이지 마세요.\n`)}`;
}
